import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import AlignLeft from './icon-align-left.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <AlignLeft {...validProps} />;
}
SvgComponent.iconName = 'alignLeft';

/**
 * @deprecated This is a legacy icon
 */
export const AlignLeftIcon = svgIconWrapper(SvgComponent);
